import { useState } from "react";
import { useRateQuizMutation } from "../../slices/fun_stuff/quizSlice";
import { Button, Form } from "react-bootstrap";
import StarRating from "../StarRating";


const RateQuiz = (({ setShowRateQuiz, quizId, resetQuiz }) => {
    const [rating, setRating] = useState(0);
    const [review, setReview] = useState('');

    const [rateQuiz] = useRateQuizMutation();

    const submitHandler = async () => {
        if (!rating) {
            window.alert("You must enter a rating for it to be logged. Sorry, no ratings of 0.");
            return;
        }
        console.log(`Rating: ${rating} | Review: ${review}`)
        await rateQuiz({
            rating, 
            review,
            quiz_id: quizId,
        });
        setShowRateQuiz(false);
        resetQuiz();
    }

    const noRatingHandler = () => {
        setShowRateQuiz(false);
        resetQuiz();
    }

    return (
        <div className="modal-overlay">
            <div className="modal-box">
                <h4>Rate Quiz</h4>

                <StarRating onChange={setRating} rating={rating} />

                <Form.Group controlId="review" className="my-2">
                    <Form.Label>Review</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="(Optional) Give detailed review"
                        onChange={(e) => setReview(e.target.value)}
                    />
                </Form.Group>

                <div className="d-flex justify-content-evenly">
                    <Button className="quiz-btn-dark" onClick={() => submitHandler()}>
                        Submit
                    </Button>
                    
                    <Button className="quiz-btn-dark" onClick={() => noRatingHandler()}>
                        No Thanks
                    </Button>
                </div>
            </div>

        </div>
    );
})

export default RateQuiz